import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Row, Steps, Col } from "antd";
import "./style.css";
import { activityTracker_key } from "../../../Constant";

const ActivityHistoryCard = ({ data }) => {
  if (!data) return null;
  let newdata = [...data].reverse();
  newdata = newdata.filter((ei) => ei.taskType != null);
  return (
    <div className="cg-activity-card">
      <div className="cg-activity-header">
        <label>Activity History</label>
      </div>
      <Row>
        <Col lg={8} md={8} xs={8}>
          <div className="cg-activity-tracker-date">
            <Steps
              progressDot
              current={newdata.length}
              direction="vertical"
              size="small"
              items={newdata.map((ei) => {
                const date = ei.startDate.split(" ");
                return {
                  title: date[0],
                };
              })}
            />
          </div>
        </Col>
        <Col lg={16} md={16} xs={16}>
          <div className="cg-activity-tracker">
            <Steps
              current={newdata.length}
              direction="vertical"
              size="small"
              items={newdata.map((ei) => {
                return {
                  key: ei.taskType,
                  icon: (
                    <FontAwesomeIcon icon={faCheckCircle} color="#50b848" />
                  ),
                  title: (
                    <div
                      className="activity_clas"
                      style={{ fontSize: "12px", fontWeight: "normal" }}
                    >
                      {activityTracker_key(ei.taskType)}
                    </div>
                  ),
                };
              })}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ActivityHistoryCard;
